import { assetRegistry } from '../lib/assets/registry';

type BrandLogoVariant = 'header' | 'sidebar' | 'horizontal-light' | 'horizontal-dark';
type Props = { className?: string; variant?: BrandLogoVariant };

const logoByVariant: Record<BrandLogoVariant, string> = {
  header: assetRegistry.brand.logoHeader,
  sidebar: assetRegistry.brand.logoSidebar,
  'horizontal-light': assetRegistry.brand.logoHorizontalLight,
  'horizontal-dark': assetRegistry.brand.logoHorizontalDark,
};

export function BrandLogo({ className = 'brand-logo', variant = 'header' }: Props) {
  return <img className={className} src={logoByVariant[variant]} alt="BelajarKu" draggable={false} />;
}
